function normalizeText(text) {
  return (text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function buildPostMarkup(item, arrowIcon) {
  const title = escapeHtml(item.title || '')
  const link = escapeHtml(item.link || '')
  const date = escapeHtml(item.date || '')
  const excerpt = escapeHtml(item.excerpt || '')
  const cat = escapeHtml(item.cat || '')
  const catSlug = escapeHtml(item.cat_slug || '')
  const image = escapeHtml(item.image || '')

  const imgHtml = image
    ? `<picture><img src="${image}" alt="${title}"></picture>`
    : ''

  return `
    <a href="${link}" class="row-blog group" data-cat="${catSlug}">
      <div class="absolute top-0 left-0 line w-full"></div>
      <div class="col-1-10 xg:col-1-4 grid xg:grid-cols-2 mb-4">
        <div class="date">${date}</div>
      </div>
      <div class="col-1-10 xg:col-5-9 mb-3 xg:mb-0">
        <h2>${title}</h2>
      </div>
      <div class="col-1-10 xg:col-9-12 flex h-full flex-col justify-between">
        <p>${excerpt}</p>
        <p class="text-red">${cat}</p>
      </div>
      <div class="col-10-13 xg:col-12-13">
        <figure class="arrow-icon">
          <img src="${escapeHtml(arrowIcon)}" alt="" loading="lazy" decoding="async">
          <img src="${escapeHtml(arrowIcon)}" alt="" loading="lazy" decoding="async">
        </figure>
      </div>
      ${imgHtml}
    </a>
  `
}

function initBlogFilterSystem() {
  const list = document.querySelector('.blog-list')
  const filterRoot = document.getElementById('cat-filter')
  const searchInput = document.getElementById('search')
  const searchButton = document.getElementById('search-button')
  const trigger = document.getElementById('cat-filter-trigger')
  const label = document.getElementById('cat-filter-label')
  const menu = document.getElementById('cat-filter-menu')
  const paginationNav = document.getElementById('blog-pagination')

  if (!list || !filterRoot || !searchInput || !trigger || !menu) {
    return
  }

  const endpoint = list.dataset.endpoint || ''
  if (!endpoint) {
    return
  }

  const isInitialized = filterRoot.dataset.initialized === 'true'

  const state = filterRoot.__blogFilterState || {
    searchTerm: '',
    category: '*',
    page: parseInt(list.dataset.currentPage || '1', 10) || 1,
    perPage: parseInt(list.dataset.perPage || '9', 10) || 9,
    totalPages: parseInt(list.dataset.totalPages || '1', 10) || 1,
    totalItems: 0,
    isLoading: false,
    searchTimeout: null,
    requestToken: 0
  }
  filterRoot.__blogFilterState = state

  const arrowIcon = list.dataset.arrowIcon || ''
  const excludeId = list.dataset.exclude || ''

  const getNoResultsNode = () => {
    let node = document.getElementById('no-results-message')
    if (!node) {
      node = document.createElement('div')
      node.id = 'no-results-message'
      node.className = 'hidden pt-8 pb-20 opacity-60'
      node.textContent = 'No se encontraron publicaciones con los filtros actuales.'
      list.insertAdjacentElement('afterend', node)
    }
    return node
  }

  const getOptions = () => menu ? Array.from(menu.querySelectorAll('.cat-option')) : []

  const updateActiveOption = () => {
    getOptions().forEach((option) => {
      const isActive = option.dataset.value === state.category
      option.classList.toggle('opacity-100', isActive)
      option.classList.toggle('opacity-80', !isActive)
    })
  }

  const resultsCountNumber = document.getElementById('results-count-number')

  const updateResultsCount = (count) => {
    if (resultsCountNumber) {
      resultsCountNumber.textContent = count
    }
  }

  const updateNoResults = (itemCount) => {
    const noResults = getNoResultsNode()
    noResults.classList.toggle('hidden', itemCount !== 0 || state.isLoading)
  }

  const setLoading = (value) => {
    state.isLoading = value
    list.dataset.loading = value ? '1' : '0'
  }

  const scrollToFilter = () => {
    const lenis = window.lenisInstance
    if (lenis) {
      lenis.scrollTo('#search-filter', { duration: 1.2 })
    } else {
      const el = document.getElementById('search-filter')
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const updateUrl = (page, { clean = false } = {}) => {
    const url = new URL(window.location)
    // Always include page parameter to ensure transitions.js excludes it
    url.searchParams.set('page', String(page))
    if (state.searchTerm) {
      url.searchParams.set('search', state.searchTerm)
    } else {
      url.searchParams.delete('search')
    }
    if (state.category && state.category !== '*') {
      url.searchParams.set('category', state.category)
    } else {
      url.searchParams.delete('category')
    }
    if (clean) {
      url.searchParams.set('clean', 'true')
    } else {
      url.searchParams.delete('clean')
    }
    history.pushState({ blogPage: page }, '', url)
  }

  const renderPosts = (items) => {
    // Conservar la línea final
    const lastLine = list.querySelector('.line.clipline:last-child')
    list.innerHTML = ''

    if (items.length) {
      const html = items.map((item) => buildPostMarkup(item, arrowIcon)).join('')
      list.insertAdjacentHTML('beforeend', html)
    }

    // Re-agregar línea divisora final
    if (lastLine) {
      list.appendChild(lastLine)
    } else {
      const line = document.createElement('div')
      line.className = 'line w-full clipline'
      line.dataset.start = 'top 80%'
      list.appendChild(line)
    }

    updateNoResults(items.length)

    if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
      requestAnimationFrame(() => window.ScrollTrigger.refresh())
    }
  }

  let prevArrowHtml = null
  let nextArrowHtml = null

  const renderPagination = () => {
    if (!paginationNav) return

    if (state.totalPages <= 1) {
      paginationNav.style.display = 'none'
      return
    }

    // Capturar SVGs de flechas solo la primera vez
    if (!prevArrowHtml) {
      prevArrowHtml = paginationNav.querySelector('.pagination-prev')?.innerHTML || '&laquo;'
    }
    if (!nextArrowHtml) {
      nextArrowHtml = paginationNav.querySelector('.pagination-next')?.innerHTML || '&raquo;'
    }

    paginationNav.style.display = ''
    const current = state.page
    const total = state.totalPages
    const maxVisible = 5

    // Calcular rango visible
    let startPage = Math.max(1, current - Math.floor(maxVisible / 2))
    let endPage = startPage + maxVisible - 1
    if (endPage > total) {
      endPage = total
      startPage = Math.max(1, endPage - maxVisible + 1)
    }

    let html = ''

    // Prev
    const prevDisabled = current <= 1
    html += `<button type="button" class="pagination-prev p-2 ${prevDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-70'}" ${prevDisabled ? 'disabled' : ''} data-page="${current - 1}">`
    html += prevArrowHtml
    html += '</button>'

    // Ellipsis start
    if (startPage > 1) {
      html += `<button type="button" class="pagination-num px-3 py-1 opacity-60 hover:opacity-100" data-page="1">1</button>`
      if (startPage > 2) {
        html += `<span class="px-1 opacity-40">&hellip;</span>`
      }
    }

    // Números
    for (let p = startPage; p <= endPage; p++) {
      const isActive = p === current
      html += `<button type="button" class="pagination-num px-3 py-1 ${isActive ? 'text-red font-semibold' : 'opacity-60 hover:opacity-100'}" data-page="${p}">${p}</button>`
    }

    // Ellipsis end
    if (endPage < total) {
      if (endPage < total - 1) {
        html += `<span class="px-1 opacity-40">&hellip;</span>`
      }
      html += `<button type="button" class="pagination-num px-3 py-1 opacity-60 hover:opacity-100" data-page="${total}">${total}</button>`
    }

    // Next
    const nextDisabled = current >= total
    html += `<button type="button" class="pagination-next p-2 ${nextDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-70'}" ${nextDisabled ? 'disabled' : ''} data-page="${current + 1}">`
    html += nextArrowHtml
    html += '</button>'

    paginationNav.innerHTML = html
  }

  const rebuildCategoryOptions = (categoriesMap) => {
    if (!categoriesMap || typeof categoriesMap !== 'object') return

    const entries = Object.entries(categoriesMap)
    const optionsHtml = [
      '<button type="button" class="cat-option w-full text-left pt-2 pr-2 pb-2 hover:text-red transition-color cursor-pointer" data-value="*">Todas las categorías</button>'
    ]

    entries.forEach(([slug, name], index) => {
      const borderClass = index !== entries.length - 1 ? ' border-b border-black' : ''
      optionsHtml.push(
        `<button type="button" class="cat-option w-full text-left pt-2 pr-2 pb-2 cursor-pointer hover:text-red transition-color${borderClass}" data-value="${escapeHtml(slug)}">${escapeHtml(name)}</button>`
      )
    })

    menu.innerHTML = optionsHtml.join('')
    updateActiveOption()
  }

  const fetchPosts = async ({ reset = false, scrollUp = false, clean = false } = {}) => {
    if (state.isLoading) return

    const targetPage = reset ? 1 : state.page
    const params = new URLSearchParams({
      page: String(targetPage),
      per_page: String(state.perPage)
    })

    if (reset) {
      params.set('include_categories', '1')
    }

    const normalizedSearch = normalizeText(state.searchTerm)
    if (normalizedSearch) {
      params.set('search', state.searchTerm)
    }
    if (state.category && state.category !== '*') {
      params.set('category', state.category)
    }
    if (excludeId) {
      params.set('exclude', excludeId)
    }

    state.requestToken += 1
    const currentToken = state.requestToken
    setLoading(true)

    try {
      const response = await fetch(`${endpoint}?${params.toString()}`, {
        method: 'GET',
        headers: { Accept: 'application/json' }
      })

      if (!response.ok) {
        throw new Error('No se pudieron cargar las publicaciones')
      }

      const data = await response.json()

      if (currentToken !== state.requestToken) return

      const items = Array.isArray(data.items) ? data.items : []
      renderPosts(items)

      if (reset && data.categories) {
        rebuildCategoryOptions(data.categories)
      }

      state.page = data?.pagination?.page || targetPage
      state.totalPages = data?.pagination?.total_pages || 1
      state.totalItems = data?.pagination?.total_items || 0
      list.dataset.currentPage = String(state.page)
      list.dataset.totalPages = String(state.totalPages)

      updateResultsCount(items.length)
      renderPagination()
      updateUrl(state.page, { clean })

      if (scrollUp) {
        scrollToFilter()
      }
    } catch (error) {
      console.error('[Blog] fetchPosts error:', error)
      renderPosts([])
    } finally {
      setLoading(false)
      updateNoResults(list.querySelectorAll('.row-blog').length)
    }
  }

  const openMenu = () => {
    menu.classList.remove('hidden')
    trigger.setAttribute('aria-expanded', 'true')
  }

  const closeMenu = () => {
    menu.classList.add('hidden')
    trigger.setAttribute('aria-expanded', 'false')
  }

  const toggleMenu = () => {
    if (menu.classList.contains('hidden')) {
      openMenu()
    } else {
      closeMenu()
    }
  }

  let lastToggleAt = 0
  const toggleThrottleMs = 180

  const handleTriggerActivate = (event) => {
    if (event.type === 'pointerdown' && event.button !== 0) return

    const now = Date.now()
    if (now - lastToggleAt < toggleThrottleMs) return

    event.preventDefault()
    event.stopPropagation()
    lastToggleAt = now
    toggleMenu()
  }

  const runRemoteSearch = () => {
    state.page = 1
    const isClean = !state.searchTerm && (!state.category || state.category === '*')
    fetchPosts({ reset: true, clean: isClean })
  }

  if (!isInitialized) {
    trigger.addEventListener('pointerdown', handleTriggerActivate)
    trigger.addEventListener('click', handleTriggerActivate)

    menu.addEventListener('click', (event) => {
      const option = event.target.closest('.cat-option')
      if (!option) return

      state.category = option.dataset.value || '*'
      label.textContent = option.textContent.trim()
      updateActiveOption()
      closeMenu()
      runRemoteSearch()
    })

    if (!window.__blogFilterOutsideClickBound) {
      document.addEventListener('click', (event) => {
        if (!filterRoot.contains(event.target)) {
          closeMenu()
        }
      })
      window.__blogFilterOutsideClickBound = true
    }

    if (!window.__blogFilterKeydownBound) {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMenu()
        }
        if (event.key === 'Enter' && document.activeElement === searchInput) {
          event.preventDefault()
          state.searchTerm = searchInput.value.trim()
          runRemoteSearch()
        }
      })
      window.__blogFilterKeydownBound = true
    }

    searchInput.addEventListener('input', (event) => {
      clearTimeout(state.searchTimeout)
      state.searchTimeout = setTimeout(() => {
        state.searchTerm = event.target.value.trim()
        runRemoteSearch()
      }, 250)
    })

    searchButton?.addEventListener('click', () => {
      state.searchTerm = searchInput.value.trim()
      runRemoteSearch()
    })

    // Paginación — delegación de eventos
    if (paginationNav) {
      paginationNav.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-page]')
        if (!btn || btn.disabled) return

        const targetPage = parseInt(btn.dataset.page, 10)
        if (isNaN(targetPage) || targetPage < 1 || targetPage > state.totalPages) return
        if (targetPage === state.page) return

        state.page = targetPage
        fetchPosts({ reset: false, scrollUp: true })
      })
    }

    // Back/forward del navegador
    if (!window.__blogPopstateBound) {
      window.addEventListener('popstate', (event) => {
        const urlPage = parseInt(
          new URL(window.location).searchParams.get('page') || '1', 10
        ) || 1
        state.page = urlPage
        fetchPosts({ reset: false, scrollUp: false })
      })
      window.__blogPopstateBound = true
    }

    filterRoot.dataset.initialized = 'true'
  }

  // Restaurar estado visual
  searchInput.value = state.searchTerm
  const currentOption = getOptions().find((option) => option.dataset.value === state.category)
  if (currentOption) {
    label.textContent = currentOption.textContent.trim()
  }

  updateActiveOption()
  renderPagination()
}

function scheduleInitBlogFilterSystem() {
  initBlogFilterSystem()

  setTimeout(() => {
    initBlogFilterSystem()
  }, 120)

  setTimeout(() => {
    initBlogFilterSystem()
  }, 350)
}

function searchFilterBlog() {
  window.__blogFilterHandledByModule = true
  scheduleInitBlogFilterSystem()

  if (!window.__blogBarbaHookAdded && typeof barba !== 'undefined') {
    barba.hooks.after(() => {
      scheduleInitBlogFilterSystem()
    })
    window.__blogBarbaHookAdded = true
  }

  if (!window.__blogTransitionListenerAdded) {
    window.addEventListener('page-transition-complete', () => {
      scheduleInitBlogFilterSystem()
    })
    window.__blogTransitionListenerAdded = true
  }
}

export default searchFilterBlog
